import script from "./Temp.vue?vue&type=script&lang=js"
export * from "./Temp.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__